import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import shared from './shared'
import settings from './settings'
import organizations from './organizations'

import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({ user: state.user, settings: state.settings })
})

export const store = new Vuex.Store({
  modules: {
    user: user,
    shared: shared,
    settings: settings,
    organizations: organizations
  },
  plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js